import React, { useEffect } from "react";
import { Card, Container, Nav, Tab } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { useDispatch } from "react-redux";
import axios from "axios";

// Components
import Projects from "./components/tables/Projects";
import Filters from "./components/Filters";
import CeilingVirement from "./components/tab-content/CeilingVirement";
import EditProjectName from "./components/tab-content/EditProjectName";
import EditProjectScopes from "./components/tab-content/EditProjectScopes";
import LocationChanges from "./components/tab-content/LocationChanges";
import ApplyNewProjects from "./components/tab-content/ApplyNewProjects";

// redux
import { getVirementApplications } from "../../../redux/slices/jppn/jppnCeilingVirementSlice";
import { getProjectNameChangesApplications } from "../../../redux/slices/jppn/jppnProjectNameChanges";
import { getProjectScopesChangesApplications } from "../../../redux/slices/jppn/jppnProjectScopesChanges";
import { getLocationChangesApplications } from "../../../redux/slices/jppn/jppnLocationChangesSlice";
import { getNewProjectApplications } from "../../../redux/slices/jppn/jppnApplyNewProjectSlice";

const MainPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    let source = axios.CancelToken.source();

    const initialize = async () => {
      const props = {
        source: source,
        params: {
          ministry_comments: !null,
          mof_comments: !null,
          upen_comments: !null,
          closing: !null,
        },
      };
      await dispatch(getVirementApplications(props));
      await dispatch(getProjectNameChangesApplications(props));
      await dispatch(getProjectScopesChangesApplications(props));
      await dispatch(getLocationChangesApplications(props));
      await dispatch(getNewProjectApplications(props));
    };

    initialize();

    return () => {
      source.cancel();
    };
  }, [dispatch]);

  return (
    <React.Fragment>
      <Helmet title='Perakuan JPPN | Senarai Projek' />

      <Container fluid className='p-0'>
        <div className='mb-4'>
          <h4>Senarai permohonan yang sedang menunggu kelulusan.</h4>
        </div>
        <div className='tab'>
          <Tab.Container>
            <Nav variant='tabs' fill>
              <Nav.Item>
                <Nav.Link eventKey='apply-new-project'>
                  Penyenaraian Projek Baharu
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey='ceiling-virement'>Kenaikan Siling</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey='edit-project-scopes'>
                  Perubahan Skop
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey='edit-project-name'>Ubah Tajuk</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey='location-changes'>Ubah Lokasi</Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content>
              <ApplyNewProjects eventKey='apply-new-project' />
              <CeilingVirement eventKey='ceiling-virement' />
              <EditProjectScopes eventKey='edit-project-scopes' />
              <EditProjectName eventKey='edit-project-name' />
              <LocationChanges eventKey='location-changes' />
            </Tab.Content>
          </Tab.Container>
        </div>

        {/* <Card>
          <Card.Header className='pb-0'>
            <p className='text-sm'>
              Senarai projek yang sedang menunggu diperaku oleh JPPN.
            </p>
            <Filters />
          </Card.Header>
          <Card.Body>
            <Projects />
          </Card.Body>
        </Card> */}
      </Container>
    </React.Fragment>
  );
};

export default MainPage;
